import Vue from 'vue';
import VueRouter from 'vue-router';
import VueMeta from 'vue-meta';
import store from '@/store/index';
import Home from '../views/Home.vue';

import HrDevelopersIndex from '../views/Hr/Developers/Index.vue';
import HrDevelopersShow from '../views/Hr/Developers/Show.vue';
import HrProjects from '../views/Hr/Projects/Index.vue';
import HrProjectShow from '../views/Hr/Projects/Show.vue';
import HrRecruitmentShow from '../views/Hr/Recruitments/Show.vue';
import HrRecruitmentCandidates from '../views/Hr/Recruitments/Candidates.vue';
import HrRecruitmentCandidateShow from '../views/Hr/Recruitments/Developer.vue';
import HrProjectFinance from '../views/Hr/Projects/Finance.vue';
import HrIssues from '../views/Hr/Issues/Index.vue';
import HrIssueShow from '../views/Hr/Issues/Show.vue';
import HrFavorites from '../views/Hr/Favorites.vue';

import DevelopersShow from '../views/Developers/Show.vue';
import ProjectsIndex from '../views/Projects/Index.vue';
import ProjectsShow from '../views/Projects/Show.vue';
import ProjectsCreate from '../views/Projects/Create.vue';
import ProjectsFinance from '../views/Projects/Finance.vue';
import RecruitmentShow from '../views/Recruitments/Show.vue';
import RecruitmentsCreate from '../views/Recruitments/Create.vue';
import IssuesIndex from '../views/Issues/Index.vue';
import IssueShow from '../views/Issues/Show.vue';

import Join from '../views/Join.vue';
import DeveloperJoin from '../views/Developer/Join.vue';

import PageNotFound from '../views/PageNotFound.vue';
import HrLogin from '../views/HrLogin.vue';
import Login from '../views/Login.vue';
import Register from '../views/Register.vue';
import PasswordRecovery from '../views/PasswordRecovery.vue';
import Terms from '../views/Terms.vue';

Vue.use(VueRouter);
Vue.use(VueMeta);

const routes = [
  {
    path: '/',
    name: 'home',
    component: Home,
    redirect: { name: 'hr-developers' },
    children: [
      {
        path: '/hr/developers',
        name: 'hr-developers',
        component: HrDevelopersIndex,
        meta: {
          role: ['hr', 'super_hr'],
        },
      },
      {
        path: '/hr/developers/:id',
        name: 'hr-developer-show',
        component: HrDevelopersShow,
        props: true,
        meta: {
          role: ['hr', 'super_hr'],
        },
      },
      {
        path: '/hr/favorites',
        name: 'hr-favorites',
        component: HrFavorites,
        meta: {
          role: ['hr', 'super_hr'],
        },
      },
      {
        path: '/hr/projects',
        name: 'hr-projects',
        component: HrProjects,
        meta: {
          role: ['hr', 'super_hr'],
        },
      },
      {
        path: '/hr/create-project',
        name: 'hr-project-create',
        component: ProjectsCreate,
        meta: {
          role: ['hr', 'super_hr'],
        },
      },
      {
        path: '/hr/projects/:id',
        name: 'hr-project-show',
        component: HrProjectShow,
        props: true,
        meta: {
          role: ['hr', 'super_hr'],
        },
      },
      {
        path: '/hr/projects/:projectId/create-recruitment',
        name: 'hr-recruitment-create',
        component: RecruitmentsCreate,
        props: true,
        meta: {
          role: ['hr', 'super_hr'],
        },
      },
      {
        path: '/hr/projects/:projectId/recruitment/:recruitmentId',
        name: 'hr-recruitment-show',
        component: HrRecruitmentShow,
        props: true,
        meta: {
          role: ['hr', 'super_hr'],
        },
      },
      {
        path: '/hr/projects/:projectId/recruitment/:recruitmentId/candidates/',
        name: 'hr-candidates',
        component: HrRecruitmentCandidates,
        props: true,
        meta: {
          role: ['hr', 'super_hr'],
        },
      },
      {
        path: '/hr/projects/:projectId/recruitment/:recruitmentId/candidate/:developerId',
        name: 'hr-candidate-show',
        component: HrRecruitmentCandidateShow,
        props: true,
        meta: {
          role: ['hr', 'super_hr'],
        },
      },
      {
        path: '/hr/projects/:projectId/finance/',
        name: 'hr-project-finance',
        component: HrProjectFinance,
        props: true,
        meta: {
          role: ['hr', 'super_hr'],
        },
      },
      {
        path: '/hr/issues',
        name: 'hr-issues',
        component: HrIssues,
        props: true,
        meta: {
          role: ['hr', 'super_hr'],
        },
      },
      {
        path: '/hr/issues/:issuesId',
        name: 'hr-issue-show',
        component: HrIssueShow,
        props: true,
        meta: {
          role: ['hr', 'super_hr'],
        },
      },
      {
        path: '/projects',
        name: 'projects',
        component: ProjectsIndex,
        meta: {
          role: ['client'],
        },
      },
      {
        path: '/projects/:id',
        name: 'project-show',
        component: ProjectsShow,
        props: true,
        meta: {
          role: ['client'],
        },
      },
      {
        path: '/create-project',
        name: 'project-create',
        component: ProjectsCreate,
        meta: {
          role: ['client'],
        },
      },
      {
        path: '/projects/:projectId/recruitment/:recruitmentId',
        name: 'recruitment-show',
        component: RecruitmentShow,
        props: true,
        meta: {
          role: ['client'],
        },
      },
      {
        path: '/projects/:projectId/create-recruitment',
        name: 'recruitment-create',
        component: RecruitmentsCreate,
        props: true,
        meta: {
          role: ['client'],
        },
      },
      {
        path: '/projects/:projectId/finance',
        name: 'project-finance',
        component: ProjectsFinance,
        props: true,
        meta: {
          role: ['client'],
        },
      },
      {
        path: '/issues',
        name: 'issues',
        component: IssuesIndex,
        props: true,
        meta: {
          role: ['client'],
        },
      },
      {
        path: '/issues/:issuesId',
        name: 'issue-show',
        component: IssueShow,
        props: true,
        meta: {
          role: ['client'],
        },
      },
      {
        path: '/developers/:id',
        name: 'developer-show',
        component: DevelopersShow,
        props: true,
        meta: {
          role: ['client'],
        },
      },
    ],
  },
  {
    path: '/join/:token',
    name: 'join',
    component: Join,
    props: true,
    meta: {
      isPublic: true,
    },
  },
  {
    path: '/developer/join/:step?',
    name: 'developer-join',
    component: DeveloperJoin,
    props: true,
    meta: {
      isPublic: true,
      role: ['developer'],
    },
  },
  {
    path: '*',
    name: 'page-not-found',
    component: PageNotFound,
    meta: {
      isPublic: true,
    },
  },
  {
    path: '/404',
    name: 'page-404',
    component: PageNotFound,
    meta: {
      isPublic: true,
    },
  },
  {
    path: '/login',
    name: 'login',
    component: Login,
    meta: {
      isPublic: true,
      onlyWhenLoggedOut: true,
    },
  },
  {
    path: '/register',
    name: 'register',
    component: Register,
    meta: {
      isPublic: true,
      onlyWhenLoggedOut: true,
    },
  },
  {
    path: '/password-recovery/',
    redirect: { name: 'home' },
  },
  {
    path: '/password-recovery/:token',
    name: 'password-recovery',
    component: PasswordRecovery,
    props: true,
    meta: {
      isPublic: true,
      onlyWhenLoggedOut: true,
    },
  },
  {
    path: '/hr/login',
    name: 'hr-login',
    component: HrLogin,
    meta: {
      isPublic: true,
      onlyWhenLoggedOut: true,
    },
  },
  {
    path: '/terms',
    name: 'terms',
    component: Terms,
    meta: {
      isPublic: true,
    },
  },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(to, from, savedPosition) {
    return savedPosition || { x: 0, y: 0 };
  },
});

// // eslint-disable-next-line consistent-return
router.beforeEach((to, from, next) => {
  const isPublic = to.matched.some((record) => record.meta.isPublic);
  const onlyWhenLoggedOut = to.matched.some((record) => record.meta.onlyWhenLoggedOut);
  const isUserLoggedIn = store.getters['auth/isLoggedIn'];
  const currentRoleMatchAccessLevel = to.matched.some(
    (record) => record.meta.role && record.meta.role.includes(store.state.auth.role),
  );

  if ((!isPublic && !isUserLoggedIn)) {
    if (to.meta.role.includes('hr') || to.meta.role.includes('super_hr')) {
      next('/hr/login');
    } else {
      next('/login');
    }
  }

  if ((isUserLoggedIn && onlyWhenLoggedOut)
    || (isUserLoggedIn && !currentRoleMatchAccessLevel)) {
    if (store.state.auth.role === 'developer') {
      next();
    } else if (store.state.auth.role === 'hr' || store.state.auth.role === 'super_hr') {
      next('/hr/developers');
    } else {
      next('/projects');
    }
  }

  next();
});

export default router;
